/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import { DISABLED_CLASSNAME } from '@constants';
import { Radio } from '@atoms';
import { Form } from '@organisms';

import s from './styles.module.less';

const ColorField = ({ colors = [], className, disabled, mergeColors, ...props }) => {
  const _colors = mergeColors ? Array.from(new Set([...colors, ...mergeColors])) : colors;

  return (
    <Form.Item {...props} disabled={disabled} className={clsx(className, disabled && DISABLED_CLASSNAME)}>
      <Radio.Group className={s.custom}>
        {_colors.map((color, index) => (
          <Radio.ColorPickerButton key={index} color={color} value={color} />
        ))}
      </Radio.Group>
    </Form.Item>
  );
};

export default ColorField;
